let config = {};

config.baseURL = 'https://api.projetos.innovareti.com.br/api/v1/';
config.normalURL = 'https://api.projetos.innovareti.com.br';

export default config
